import { render } from "./SpotifySegment.vue?vue&type=template&id=c82f54c2"
import script from "./SpotifySegment.vue?vue&type=script&lang=js"
export * from "./SpotifySegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__